import React, { Component } from 'react';

class About extends Component {
  render() {

    if(this.props.data){
      var name = this.props.data.name;
      var profilepic= "images/"+this.props.data.image;
      var street = this.props.data.address.street;
      var city = this.props.data.address.city;
      var state = this.props.data.address.state;
      var zip = this.props.data.address.zip;
      var phone= this.props.data.phone;
      var email = this.props.data.email;
      var docDownload = this.props.data.docdownload;

      var func = this.props.data.func.map(function(func){
        return <div key={func.module}><h3>{func.module}</h3>
            <p>{func.description}</p>
        </div>
      })
    }

    return (
      <section id="about">
      <div className="row">
         <div className="three columns">
            <img className="login-pic"  src={profilepic} alt="Opsbook login pic" />
         </div>
         <div className="nine columns main-col">
            <h2>Key functions</h2>
            <p>{func}</p>

            <div className="row">
               <div className="columns download">
                  <p>
                     <a href={docDownload} className="button"><i className="fa fa-download"></i>Download Introduction (中文)</a>
                  </p>
               </div>
            </div>
         </div>
      </div>

   </section>
    );
  }
}

export default About;



// WEBPACK FOOTER //
// ./src/Components/About.js